import { WalletIcon } from "lucide-react"
export default function WalletAuthenticate({walletAuthenticate}: {walletAuthenticate: boolean}) {
    

    if (walletAuthenticate) {
        return (
            <section className="px-4 py-10 flex flex-col items-center justify-center text-center">
                <WalletIcon className="w-32 h-32 mb-6 text-purple-600" />
                <h3 className="text-2xl font-bold text-purple-900 mb-2">
                    {"Åpne Wallet for å bekrefte betalingen"}
                </h3>
                <p className="text-gray-600 mb-6 max-w-sm">
                    {"Vi har sendt en forespørsel til Wallet. Vennligst åpne appen og bekreft for å fortsette."}
                </p>
                <div className="animate-pulse text-purple-600 font-medium">
                    {"Venter på bekreftelse…"}
                </div>
            </section>
        )
    }
}